module.exports = __webpack_public_path__ + "img/rotacaoauto2.c51b6db7.png";